import axios from 'axios';
import { Button } from 'primereact/button';
import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';
import React, { useContext, useEffect, useRef, useState } from 'react';
import { ConfigContext } from '../../Context/ConfigContext';
import { Toast } from 'primereact/toast';
import { Skeleton } from 'primereact/skeleton';
import { useParams } from 'react-router-dom';
import { Card } from 'primereact/card';
import { TabView, TabPanel } from 'primereact/tabview';
import { formatDatetime } from '../../Helper/constent';
import { Tag } from 'primereact/tag';

const ViewStockTransfer = () => {
    const [rows, setRows] = useState([]);
    const [inactiveRows, setInactiveRows] = useState([]);
    const [transferDetails, setTransferDetails] = useState(null);
    const { apiUrl, apiHeadersJson } = useContext(ConfigContext);
    const toast = useRef(null);
    const { inv_transfer_id, purchase_id } = useParams();
    const [loading, setLoading] = useState(true);

    const headers = apiHeadersJson;

    const fetchTransferData = async () => {
        setLoading(true);
        try {
            const response = await axios.get(`${apiUrl}/Management/GetStockTransferProducts`, {
                params: { inv_transfer_id, purchase_id, type: 1 },
                headers,
            });
            const { success, data, rows, inactive_rows, message } = response.data;
            if (success) {
                setTransferDetails(data[0]);
                setRows(rows || []);
                setInactiveRows(inactive_rows || []);
            } else {
                toast.current.show({ severity: 'error', summary: 'Error', detail: message, life: 3000 });
            }
        } catch (error) {
            console.error('Error fetching data:', error);
            toast.current.show({ severity: 'error', summary: 'Error', detail: 'Failed to fetch data.', life: 3000 });
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (inv_transfer_id) {
            fetchTransferData();
        }
    }, [inv_transfer_id]);

    const renderTransferDetails = () => {
        if (!transferDetails) return null;
        return (
            <div className="grid">
                <div className="col-12 lg:col-6">
                    <Card title="Transfer Information">
                        <div>
                            <p><strong>Transfer ID:</strong> {transferDetails.inv_transfer_id}</p>
                            <p><strong>Invoice Number:</strong> {transferDetails.invoice_number}</p>
                            <p><strong>Date & Time:</strong> {formatDatetime(transferDetails.created_date)}</p>
                            <p><strong>Total Amount:</strong> {transferDetails.grand_total_amount}</p>
                            <div className="d-flex justify-content-between align-items-center">
                                <p><strong>Bill By:</strong> {transferDetails.bill_by}</p>
                                {transferDetails.last_action_by && <p><strong>Last Action By:</strong> {transferDetails.last_action_by}</p>}
                            </div>
                        </div>
                    </Card>
                </div>
                <div className="col-12 lg:col-6">
                    <Card title="Store Information">
                        <div>
                            <p><strong>From Store:</strong> {transferDetails.from_store_name}</p>
                            <p><strong>To Store:</strong> {transferDetails.to_store_name}</p>
                            <p><strong>Status:</strong> {transferDetails.action_type === '1' ? 'Verified' : 'Pending'}</p>
                            {transferDetails.action_by_user && <p><strong>Verified By:</strong> {transferDetails.action_by_user}</p>}
                        </div>
                    </Card>
                </div>
            </div>
        );
    };

    const actionBy = (data) => {
        let value = data.stock_status === 2 ? `Edited By ${data.user_name}` : 
                    data.stock_status === 3 ? `Deleted By ${data.user_name}` : '';
        let severity = data.stock_status == 2 ? 'info' : data.stock_status == 3 ? 'danger' : '';
        return (
            <Tag severity={severity} value={value} />
        )
    };

    const actionDateTime = (data) => {
        return formatDatetime(data.updated_date);
    };

    const stockDirection = (data) => {
        return data.stock_voucher_type === 'ST' ? 'Stock Out' : 'Stock In';
    };

    return (
        <div className="container-fluid">
            <Toast ref={toast} />
            <div className="mt-4">
                {loading ? (
                    <Skeleton width="100%" height="300px" />
                ) : (
                    renderTransferDetails()
                )}
            </div>

            <div className="mt-4">
                <TabView>
                    <TabPanel header="Active Products">
                        {loading ? (
                            <Skeleton width="100%" height="200px" />
                        ) : (
                            <DataTable
                                value={rows}
                                rows={10}
                                stripedRows
                                responsiveLayout="scroll"
                                className="p-datatable-sm"
                                emptyMessage="No active products found"
                            >
                                <Column field="product_name" header="Product Name" />
                                <Column field="store_name" header="Store" />
                                <Column body={stockDirection} header="Stock Type" />
                                <Column field="product_qty" header="Quantity" />
                                <Column field="stock_purchase_price" header="Purchase Price" />
                                <Column field="stock_sale_price" header="Sale Price" />
                                <Column field="total_amount" header="Total Amount" />
                            </DataTable>
                        )}
                    </TabPanel>
                    <TabPanel header="Transfer History">
                        {loading ? (
                            <Skeleton width="100%" height="200px" />
                        ) : (
                            <DataTable
                                value={inactiveRows}
                                rows={10}
                                stripedRows
                                responsiveLayout="scroll"
                                className="p-datatable-sm"
                                >
                                <Column field="product_name" header="Product Name" />
                                <Column field="store_name" header="Store" />
                                <Column body={stockDirection} header="Stock Type" />
                                <Column field="product_qty" header="Quantity" />
                                <Column field="stock_purchase_price" header="Purchase Price" />
                                <Column field="stock_sale_price" header="Sale Price" />
                                <Column field="total_amount" header="Total Amount" />
                                <Column body={actionDateTime} header="Date & Time" />
                                <Column header="Action By" body={actionBy} />
                            </DataTable>
                        )}
                    </TabPanel>
                </TabView>
            </div>
        </div>
    );
};

export default ViewStockTransfer;